import React from "react";

const pickUpTimeConstants: { [key: number]: { from: string, to: string } } = {
    0: {from: "10:00", to: "13:00"},
    1: {from: "13:00", to: "15:00"},
    2: {from: "15:00", to: "17:00"},
    3: {from: "10:00", to: "18:00"}
};

const countryConstants: string[] = ["Deutschland","Österreich","Schweiz"];

export const selectedCountryToString = (index: number) => countryConstants[index];

export const pickUpTimeToStringLong = (selectedTime: number): string =>
    `${pickUpTimeConstants[selectedTime].from} Uhr - ${pickUpTimeConstants[selectedTime].to} Uhr`;

export const pickUpTimeToStringShort = (selectedTime: number): string =>
    `${pickUpTimeConstants[selectedTime].from}-${pickUpTimeConstants[selectedTime].to}`;

export const selectOptions = {
    time: [
        <option value={0} key={0}>{pickUpTimeToStringLong(0)}</option>,
        <option value={1} key={1}>{pickUpTimeToStringLong(1)}</option>,
        <option value={2} key={2}>{pickUpTimeToStringLong(2)}</option>,
        <option value={3} key={3}>{pickUpTimeToStringLong(3)}</option>
    ],
    country: countryConstants.map((country, index) => <option value={index} key={index}>{country}</option>)
};
